
















import { Component, Vue, Provide } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import NewIdea from './NewIdea.vue';

@Component({
    components: {
        NewIdea,
    },
})
export default class Navbar extends Vue {
    @Provide() public newIdea: boolean = false;
    @Getter public isLogin: any;

    public refresh() {
        this.$emit('refresh');
    }
}
